import type { useOpenNotification } from './antd/notification-toasts';

export const triggerDownload = (blob: Blob, filename: string) => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const handleError = (
  openNotification: ReturnType<typeof useOpenNotification>,
  message: string
) => {
  openNotification({
    kind: 'error',
    message: message
  });
};
